/**
 * @returns {object} list of default cookies that could be set in Touchweb
 * @desc
 * key: Cookie Name
 * default: Default Value if not set
 * length: Time to be stored (months)
 */
export const DEFAULT_COOKIES = {
    ITEM_LAYOUT: {
        key: 'Srp_Item_Layout',
        default: 'layout-grid',
        length: 6
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/constants/cookies.js